// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formTable__cell {\n  display: table-cell;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  width: 100%;\n}\n.formTable__cell:first-child {\n  padding-left: 0;\n}\n.formTable__cell:last-child {\n  padding-right: 0;\n}\n.formTable__cell--header {\n  white-space: nowrap;\n  width: auto;\n}\n.formTable__cell .v-text-field {\n  padding-top: 0;\n  margin-top: 0;\n}\n.formTable__cell .v-input--checkbox {\n  padding-top: 0;\n  margin-top: 0;\n  position: relative;\n  top: 8px;\n}", ""]);
// Exports
module.exports = exports;
